import { useContext } from "react";
import { TenderTimeContext } from "../context/TenderTimeContext";
import { useCapturedServerTime } from "./useCapturedServerTime";

export const useServerClock = (enabled = true, refreshKey) => {
  const scope = useContext(TenderTimeContext);
  const snapshot = useCapturedServerTime(enabled && !scope, refreshKey);
  const clock = scope?.clock || snapshot;
  return { ...clock, isReady: !enabled || clock.isReady };
};
